import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=0bd9d531&scoped=true"
import script from "./DealList.vue?vue&type=script&lang=js"
export * from "./DealList.vue?vue&type=script&lang=js"
import style0 from "./DealList.vue?vue&type=style&index=0&id=0bd9d531&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9d531",
  null
  
)

export default component.exports